<template>
    <div class="patient-details">
        <div class="profile-status">
            <p class="fw-bold">{{ selectedPatientDetails.Branch }}</p>
            <div class="pic">
                <span
                    v-if="patientDetails.PhotoUrl"
                    class="uploaded-pic"
                    ref="userPicElement"
                    :style="{ backgroundImage: `url(${patientDetails.PhotoUrl})` }"
                ></span>
                <i v-else class="no-pic fas fa-user"></i>
            </div>
            <p class="fw-bold">
                {{ String(statusEnum.getDescriptionUsingValue(selectedPatientDetails.Status)).toLocaleUpperCase() }}
            </p>
        </div>
        <HHPatientMain
            :selectedPatientDetails="selectedPatientDetails"
            :patientRiskDetails="patientRiskDetails"
            :patientDetails="patientDetails"
        />
    </div>
</template>

<script lang="ts" src="./HHProfileDetails.ts"></script>
